import { StreamActions } from "@hotwired/turbo";

// Un broadcast-signal : pas de HTML transporté, la cible (un turbo-frame, ou un élément dans
// un frame) se recharge — le refresh canonique de Turbo 8, scopé à un frame (le core n'a pas
// d'action officielle pour ça ; équivalent du turbo_frame_reload de turbo_power). Le rendu
// passe alors par le chemin frame — refresh="morph" + data-turbo-permanent y protègent
// l'état client lourd (canvas fabric des îlots composition).
StreamActions.reload_frame = function () {
  this.targetElements.forEach((el) => {
    el.closest("turbo-frame")?.reload();
  });
};
